import { httpRequest, endpoint } from "@cirrus/core/http"

export const profileGet = async () =>
  await httpRequest.get(endpoint.withRoot("/api/v1/user/profile"))

export const settingsGet = async () =>
  await httpRequest.get(endpoint.withRoot("/api/v1/user/settings"))
